/**
 * Generated by orval v8.4.0 🍺
 * Do not edit manually.
 * Medme Marketing PRM API
 * API для автоматизированных маркетинговых рассылок и выгрузок (MedMe PRM).

**Разделы продукта:**
- **Рассылки** — отправка сообщений по сегменту (разово или по расписанию)
- **Выгрузки** — таблица пациентов по сегменту (файл, опционально e-mail с архивом)
- **Отчётность** — журнал запусков и доставки

**Авторизация:** HttpOnly cookie `token` (JWT), как в stats-api. Получение токена — через `GET /auth` stats-api.

**Контекст организации:** API работает с понятием «организация» — всем списком бизнесов, к которым у пользователя есть доступ. Сервер резолвит бизнесы автоматически из JWT-токена; `businessId` в query-параметрах не передаётся. Для операций над конкретным бизнесом (создание задачи, принятие условий) `businessId` передаётся в теле запроса.

 * OpenAPI spec version: 1.0.0
 */

import type {
	DataTag,
	DefinedInitialDataOptions,
	DefinedUseQueryResult,
	MutationFunction,
	QueryClient,
	QueryFunction,
	QueryKey,
	UndefinedInitialDataOptions,
	UseMutationOptions,
	UseMutationResult,
	UseQueryOptions,
	UseQueryResult,
} from "@tanstack/react-query"
import { useMutation, useQuery } from "@tanstack/react-query"
import { customFetch } from "../../custom-marketing-client"
import type {
	BadRequestResponse,
	DefaultErrorResponse,
	ForbiddenResponse,
	MarketingContextResponse,
	MarketingTimezonesResponse,
	UnauthorizedResponse,
} from ".././types/marketing"

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

export type HTTPStatusCode1xx = 100 | 101 | 102 | 103
export type HTTPStatusCode2xx = 200 | 201 | 202 | 203 | 204 | 205 | 206 | 207
export type HTTPStatusCode3xx = 300 | 301 | 302 | 303 | 304 | 305 | 307 | 308
export type HTTPStatusCode4xx =
	| 400
	| 401
	| 402
	| 403
	| 404
	| 405
	| 406
	| 407
	| 408
	| 409
	| 410
	| 411
	| 412
	| 413
	| 414
	| 415
	| 416
	| 417
	| 418
	| 419
	| 420
	| 421
	| 422
	| 423
	| 424
	| 426
	| 428
	| 429
	| 431
	| 451
export type HTTPStatusCode5xx = 500 | 501 | 502 | 503 | 504 | 505 | 507 | 511
export type HTTPStatusCodes =
	| HTTPStatusCode1xx
	| HTTPStatusCode2xx
	| HTTPStatusCode3xx
	| HTTPStatusCode4xx
	| HTTPStatusCode5xx

/**
 * Возвращает флаги доступа, баланс маркетинговых SMS, лимит на рассылку и часовой пояс.
Вызывается при входе в раздел «Маркетинг». Бизнесы определяются автоматически из JWT-токена.

 * @summary Контекст маркетинга для организации
 */
export type MarketingContextGetMarketingContextResponse200 = {
	data: MarketingContextResponse
	status: 200
}

export type MarketingContextGetMarketingContextResponse400 = {
	data: BadRequestResponse
	status: 400
}

export type MarketingContextGetMarketingContextResponse401 = {
	data: UnauthorizedResponse
	status: 401
}

export type MarketingContextGetMarketingContextResponse403 = {
	data: ForbiddenResponse
	status: 403
}

export type MarketingContextGetMarketingContextResponseDefault = {
	data: DefaultErrorResponse
	status: Exclude<HTTPStatusCodes, 200 | 400 | 401 | 403>
}

export type MarketingContextGetMarketingContextResponseSuccess =
	MarketingContextGetMarketingContextResponse200 & {
		headers: Headers
	}
export type MarketingContextGetMarketingContextResponseError = (
	| MarketingContextGetMarketingContextResponse400
	| MarketingContextGetMarketingContextResponse401
	| MarketingContextGetMarketingContextResponse403
	| MarketingContextGetMarketingContextResponseDefault
) & {
	headers: Headers
}

export type MarketingContextGetMarketingContextResponse =
	| MarketingContextGetMarketingContextResponseSuccess
	| MarketingContextGetMarketingContextResponseError

export const getMarketingContextGetMarketingContextUrl = () => {
	return `/marketing/context`
}

export const MarketingContextGetMarketingContext = async (
	options?: RequestInit,
): Promise<MarketingContextGetMarketingContextResponse> => {
	return customFetch<MarketingContextGetMarketingContextResponse>(
		getMarketingContextGetMarketingContextUrl(),
		{
			...options,
			method: "GET",
		},
	)
}

export const getMarketingContextGetMarketingContextQueryKey = () => {
	return [`/marketing/context`] as const
}

export const getMarketingContextGetMarketingContextQueryOptions = <
	TData = Awaited<ReturnType<typeof MarketingContextGetMarketingContext>>,
	TError =
		| BadRequestResponse
		| UnauthorizedResponse
		| ForbiddenResponse
		| DefaultErrorResponse,
>(options?: {
	query?: Partial<
		UseQueryOptions<
			Awaited<ReturnType<typeof MarketingContextGetMarketingContext>>,
			TError,
			TData
		>
	>
	request?: SecondParameter<typeof customFetch>
}) => {
	const { query: queryOptions, request: requestOptions } = options ?? {}

	const queryKey =
		queryOptions?.queryKey ?? getMarketingContextGetMarketingContextQueryKey()

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof MarketingContextGetMarketingContext>>
	> = ({ signal }) =>
		MarketingContextGetMarketingContext({ signal, ...requestOptions })

	return {
		queryKey,
		queryFn,
		refetchOnMount: false,
		...queryOptions,
	} as UseQueryOptions<
		Awaited<ReturnType<typeof MarketingContextGetMarketingContext>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MarketingContextGetMarketingContextQueryResult = NonNullable<
	Awaited<ReturnType<typeof MarketingContextGetMarketingContext>>
>
export type MarketingContextGetMarketingContextQueryError =
	| BadRequestResponse
	| UnauthorizedResponse
	| ForbiddenResponse
	| DefaultErrorResponse

export function useMarketingContextGetMarketingContext<
	TData = Awaited<ReturnType<typeof MarketingContextGetMarketingContext>>,
	TError =
		| BadRequestResponse
		| UnauthorizedResponse
		| ForbiddenResponse
		| DefaultErrorResponse,
>(
	options: {
		query: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof MarketingContextGetMarketingContext>>,
				TError,
				TData
			>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof MarketingContextGetMarketingContext>>,
					TError,
					Awaited<ReturnType<typeof MarketingContextGetMarketingContext>>
				>,
				"initialData"
			>
		request?: SecondParameter<typeof customFetch>
	},
	queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}
export function useMarketingContextGetMarketingContext<
	TData = Awaited<ReturnType<typeof MarketingContextGetMarketingContext>>,
	TError =
		| BadRequestResponse
		| UnauthorizedResponse
		| ForbiddenResponse
		| DefaultErrorResponse,
>(
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof MarketingContextGetMarketingContext>>,
				TError,
				TData
			>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof MarketingContextGetMarketingContext>>,
					TError,
					Awaited<ReturnType<typeof MarketingContextGetMarketingContext>>
				>,
				"initialData"
			>
		request?: SecondParameter<typeof customFetch>
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}
export function useMarketingContextGetMarketingContext<
	TData = Awaited<ReturnType<typeof MarketingContextGetMarketingContext>>,
	TError =
		| BadRequestResponse
		| UnauthorizedResponse
		| ForbiddenResponse
		| DefaultErrorResponse,
>(
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof MarketingContextGetMarketingContext>>,
				TError,
				TData
			>
		>
		request?: SecondParameter<typeof customFetch>
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}
/**
 * @summary Контекст маркетинга для организации
 */

export function useMarketingContextGetMarketingContext<
	TData = Awaited<ReturnType<typeof MarketingContextGetMarketingContext>>,
	TError =
		| BadRequestResponse
		| UnauthorizedResponse
		| ForbiddenResponse
		| DefaultErrorResponse,
>(
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof MarketingContextGetMarketingContext>>,
				TError,
				TData
			>
		>
		request?: SecondParameter<typeof customFetch>
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
} {
	const queryOptions =
		getMarketingContextGetMarketingContextQueryOptions(options)

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<
		TData,
		TError
	> & { queryKey: DataTag<QueryKey, TData, TError> }

	return { ...query, queryKey: queryOptions.queryKey }
}

/**
 * Фиксирует согласие пользователя с условиями маркетинга для всех бизнесов организации.
Аналог установки `marketingNotifications.accepted` в desktop-backoffice.

 * @summary Принять условия использования маркетинговых рассылок
 */
export type MarketingContextAcceptMarketingTermsResponse200 = {
	data: MarketingContextResponse
	status: 200
}

export type MarketingContextAcceptMarketingTermsResponse400 = {
	data: BadRequestResponse
	status: 400
}

export type MarketingContextAcceptMarketingTermsResponse401 = {
	data: UnauthorizedResponse
	status: 401
}

export type MarketingContextAcceptMarketingTermsResponse403 = {
	data: ForbiddenResponse
	status: 403
}

export type MarketingContextAcceptMarketingTermsResponseDefault = {
	data: DefaultErrorResponse
	status: Exclude<HTTPStatusCodes, 200 | 400 | 401 | 403>
}

export type MarketingContextAcceptMarketingTermsResponseSuccess =
	MarketingContextAcceptMarketingTermsResponse200 & {
		headers: Headers
	}
export type MarketingContextAcceptMarketingTermsResponseError = (
	| MarketingContextAcceptMarketingTermsResponse400
	| MarketingContextAcceptMarketingTermsResponse401
	| MarketingContextAcceptMarketingTermsResponse403
	| MarketingContextAcceptMarketingTermsResponseDefault
) & {
	headers: Headers
}

export type MarketingContextAcceptMarketingTermsResponse =
	| MarketingContextAcceptMarketingTermsResponseSuccess
	| MarketingContextAcceptMarketingTermsResponseError

export const getMarketingContextAcceptMarketingTermsUrl = () => {
	return `/marketing/context/accept-terms`
}

export const MarketingContextAcceptMarketingTerms = async (
	options?: RequestInit,
): Promise<MarketingContextAcceptMarketingTermsResponse> => {
	return customFetch<MarketingContextAcceptMarketingTermsResponse>(
		getMarketingContextAcceptMarketingTermsUrl(),
		{
			...options,
			method: "POST",
		},
	)
}

export const getMarketingContextAcceptMarketingTermsMutationOptions = <
	TError =
		| BadRequestResponse
		| UnauthorizedResponse
		| ForbiddenResponse
		| DefaultErrorResponse,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof MarketingContextAcceptMarketingTerms>>,
		TError,
		void,
		TContext
	>
	request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
	Awaited<ReturnType<typeof MarketingContextAcceptMarketingTerms>>,
	TError,
	void,
	TContext
> => {
	const mutationKey = ["marketingContextAcceptMarketingTerms"]
	const { mutation: mutationOptions, request: requestOptions } = options
		? options.mutation &&
			"mutationKey" in options.mutation &&
			options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey }, request: undefined }

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof MarketingContextAcceptMarketingTerms>>,
		void
	> = () => {
		return MarketingContextAcceptMarketingTerms(requestOptions)
	}

	return { mutationFn, ...mutationOptions }
}

export type MarketingContextAcceptMarketingTermsMutationResult = NonNullable<
	Awaited<ReturnType<typeof MarketingContextAcceptMarketingTerms>>
>

export type MarketingContextAcceptMarketingTermsMutationError =
	| BadRequestResponse
	| UnauthorizedResponse
	| ForbiddenResponse
	| DefaultErrorResponse

/**
 * @summary Принять условия использования маркетинговых рассылок
 */
export const useMarketingContextAcceptMarketingTerms = <
	TError =
		| BadRequestResponse
		| UnauthorizedResponse
		| ForbiddenResponse
		| DefaultErrorResponse,
	TContext = unknown,
>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof MarketingContextAcceptMarketingTerms>>,
			TError,
			void,
			TContext
		>
		request?: SecondParameter<typeof customFetch>
	},
	queryClient?: QueryClient,
): UseMutationResult<
	Awaited<ReturnType<typeof MarketingContextAcceptMarketingTerms>>,
	TError,
	void,
	TContext
> => {
	return useMutation(
		getMarketingContextAcceptMarketingTermsMutationOptions(options),
		queryClient,
	)
}
/**
 * Справочник часовых поясов РФ для выбора в блоке «Запуск».
Может кэшироваться на клиенте.

 * @summary Список часовых поясов для планировщика
 */
export type MarketingContextGetMarketingTimezonesResponse200 = {
	data: MarketingTimezonesResponse
	status: 200
}

export type MarketingContextGetMarketingTimezonesResponse401 = {
	data: UnauthorizedResponse
	status: 401
}

export type MarketingContextGetMarketingTimezonesResponseDefault = {
	data: DefaultErrorResponse
	status: Exclude<HTTPStatusCodes, 200 | 401>
}

export type MarketingContextGetMarketingTimezonesResponseSuccess =
	MarketingContextGetMarketingTimezonesResponse200 & {
		headers: Headers
	}
export type MarketingContextGetMarketingTimezonesResponseError = (
	| MarketingContextGetMarketingTimezonesResponse401
	| MarketingContextGetMarketingTimezonesResponseDefault
) & {
	headers: Headers
}

export type MarketingContextGetMarketingTimezonesResponse =
	| MarketingContextGetMarketingTimezonesResponseSuccess
	| MarketingContextGetMarketingTimezonesResponseError

export const getMarketingContextGetMarketingTimezonesUrl = () => {
	return `/marketing/timezones`
}

export const MarketingContextGetMarketingTimezones = async (
	options?: RequestInit,
): Promise<MarketingContextGetMarketingTimezonesResponse> => {
	return customFetch<MarketingContextGetMarketingTimezonesResponse>(
		getMarketingContextGetMarketingTimezonesUrl(),
		{
			...options,
			method: "GET",
		},
	)
}

export const getMarketingContextGetMarketingTimezonesQueryKey = () => {
	return [`/marketing/timezones`] as const
}

export const getMarketingContextGetMarketingTimezonesQueryOptions = <
	TData = Awaited<ReturnType<typeof MarketingContextGetMarketingTimezones>>,
	TError = UnauthorizedResponse | DefaultErrorResponse,
>(options?: {
	query?: Partial<
		UseQueryOptions<
			Awaited<ReturnType<typeof MarketingContextGetMarketingTimezones>>,
			TError,
			TData
		>
	>
	request?: SecondParameter<typeof customFetch>
}) => {
	const { query: queryOptions, request: requestOptions } = options ?? {}

	const queryKey =
		queryOptions?.queryKey ?? getMarketingContextGetMarketingTimezonesQueryKey()

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof MarketingContextGetMarketingTimezones>>
	> = ({ signal }) =>
		MarketingContextGetMarketingTimezones({ signal, ...requestOptions })

	return {
		queryKey,
		queryFn,
		refetchOnMount: false,
		...queryOptions,
	} as UseQueryOptions<
		Awaited<ReturnType<typeof MarketingContextGetMarketingTimezones>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MarketingContextGetMarketingTimezonesQueryResult = NonNullable<
	Awaited<ReturnType<typeof MarketingContextGetMarketingTimezones>>
>
export type MarketingContextGetMarketingTimezonesQueryError =
	| UnauthorizedResponse
	| DefaultErrorResponse

export function useMarketingContextGetMarketingTimezones<
	TData = Awaited<ReturnType<typeof MarketingContextGetMarketingTimezones>>,
	TError = UnauthorizedResponse | DefaultErrorResponse,
>(
	options: {
		query: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof MarketingContextGetMarketingTimezones>>,
				TError,
				TData
			>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof MarketingContextGetMarketingTimezones>>,
					TError,
					Awaited<ReturnType<typeof MarketingContextGetMarketingTimezones>>
				>,
				"initialData"
			>
		request?: SecondParameter<typeof customFetch>
	},
	queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}
export function useMarketingContextGetMarketingTimezones<
	TData = Awaited<ReturnType<typeof MarketingContextGetMarketingTimezones>>,
	TError = UnauthorizedResponse | DefaultErrorResponse,
>(
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof MarketingContextGetMarketingTimezones>>,
				TError,
				TData
			>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof MarketingContextGetMarketingTimezones>>,
					TError,
					Awaited<ReturnType<typeof MarketingContextGetMarketingTimezones>>
				>,
				"initialData"
			>
		request?: SecondParameter<typeof customFetch>
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}
export function useMarketingContextGetMarketingTimezones<
	TData = Awaited<ReturnType<typeof MarketingContextGetMarketingTimezones>>,
	TError = UnauthorizedResponse | DefaultErrorResponse,
>(
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof MarketingContextGetMarketingTimezones>>,
				TError,
				TData
			>
		>
		request?: SecondParameter<typeof customFetch>
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}
/**
 * @summary Список часовых поясов для планировщика
 */

export function useMarketingContextGetMarketingTimezones<
	TData = Awaited<ReturnType<typeof MarketingContextGetMarketingTimezones>>,
	TError = UnauthorizedResponse | DefaultErrorResponse,
>(
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof MarketingContextGetMarketingTimezones>>,
				TError,
				TData
			>
		>
		request?: SecondParameter<typeof customFetch>
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
} {
	const queryOptions =
		getMarketingContextGetMarketingTimezonesQueryOptions(options)

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<
		TData,
		TError
	> & { queryKey: DataTag<QueryKey, TData, TError> }

	return { ...query, queryKey: queryOptions.queryKey }
}
